import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./index.css";
import "./balder.css";
import KlimaomstillingApp from "./klimaomstilling/App";
import ProsjektlisteApp from "./prosjektliste/App";
import RapportkatalogApp from "./rapportkatalog/App";

// biome-ignore lint/style/noNonNullAssertion: always there
createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<KlimaomstillingApp />} />
                <Route path="/prosjektliste" element={<ProsjektlisteApp />} />
                <Route path="/rapportkatalog" element={<RapportkatalogApp />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
    </StrictMode>,
);
